import request from "@/utils/request";
// 获取接收人列表
export function GetReceivers(params) {
  return request({
    url: "/h5/index/getReceivers",
    method: "post",
    params,
  });
}
// 确定接收人
export function ConfirmReceiver(params) {
  return request({
    url: "/h5/index/confirmReceiver",
    method: "post",
    params,
  });
}